export default __webpack_public_path__ + "media/images/react_icons/copy_icon-3bf3520c2beebaf1b8abbbed2e8abed9.svg";